import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'common/shared.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { GatesService } from 'search/services/gates.service';
import { BulkSelectModule } from '../bulk-select/bulk-select.module';
import { EntityModule } from '../entity/entity.module';
import { LibraryListViewComponent } from './components/library-list-view/library-list-view.component';
import { LibraryListViewContainerComponent } from './components/library-list-view-container/library-list-view-container.component';
import { LibraryListRoutingModule } from './library-list-routing.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LibraryListEffects } from './effects/library-list.effects';
import * as libraryList from './reducers/library-list.reducer';
import * as fromHistory from '../search/reducers/history.reducer';
import { LibraryListHeaderComponent } from './components/library-list-header/library-list-header.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LibraryListResolver } from './resolvers/library-list.resolver';
import { FormsModule } from '@angular/forms';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  declarations: [
    LibraryListViewComponent,
    LibraryListViewContainerComponent,
    LibraryListHeaderComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(libraryList.featureKey, libraryList.reducer),
    StoreModule.forFeature('history', fromHistory.reducer),
    EffectsModule.forFeature([
      LibraryListEffects,
    ]),
    LibraryListRoutingModule,
    PerfectScrollbarModule,
    InfiniteScrollModule,
    FontAwesomeModule,
    EntityModule,
    FormsModule,
    BulkSelectModule,
  ],
  providers: [
    GatesService,
    LibraryListResolver,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
})
export class LibraryListModule {
}
